import { ILocLinkifierModel } from '../filters/LocLinkifierFilter';
import { Module } from '../Module';
import { ErrorMessageHandler } from '../services/ErrorMessageHandler';
import { WindowLocationService } from '../services/WindowLocationService';

export interface ISignInErrorScope extends ng.IScope {
  errorMessages: ILocLinkifierModel[];
  tryAgain: () => void;
}

export interface ISignInErrorStateParams extends ng.ui.IStateParamsService {
  errorCode: number;
  redirectPath: string;
}

export class SignInErrorCtrl {

  public static $inject = [
    '$scope',
    '$stateParams',
    '$location',
    'WindowLocationService',
    'ErrorMessageHandler'
  ];

  constructor(
    $scope: ISignInErrorScope,
    $stateParams: ISignInErrorStateParams,
    $location: ng.ILocationService,
    windowLocationService: WindowLocationService,
    errorMessageHandler: ErrorMessageHandler
  ) {
    // Coerse error code
    const errorCode: number = +$stateParams.errorCode;
    const redirectPath: string = $stateParams.redirectPath || '/';

    $scope.tryAgain = () => {
      // Prevent redirect injection by appending the current host to the redirect
      const target = $location.protocol() + '://' + $location.host() + ':' + $location.port() + redirectPath;
      windowLocationService.navigateToWithoutAddingToHistory(target);
    };

    $scope.errorMessages = errorMessageHandler.getSignInErrorMessages(errorCode);
  }

}

Module.instance().controller('SignInErrorCtrl', SignInErrorCtrl);
